module.exports = __webpack_public_path__ + "media/images/apple-icon-114x114-6086c05d.png";